import { render } from "./newLoan.vue?vue&type=template&id=35d4b1f0&scoped=true"
import script from "./newLoan.vue?vue&type=script&lang=js"
export * from "./newLoan.vue?vue&type=script&lang=js"

import "./newLoan.vue?vue&type=style&index=0&id=35d4b1f0&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d4b1f0"]])

export default __exports__